import { isDevelopment, isStaging } from '@/constants'
import axios, { AxiosResponse } from 'axios'
import { browserLogger } from 'lib/Logger/browserLogs'

type LocationResponse = {
  ip: string
  hostname: string
  city: string
  region: string
  country: string
  loc: string
  org: string
  postal: string
  timezone: string
}

type LocationData = {
  ip: string
  region: string
}
const SESSION_KEY = 'client-location'

export const getClientLocation = async (): Promise<LocationData | null> => {
  const mockLocation = getMockLocation()
  if (mockLocation) return mockLocation

  const cached = sessionStorage.getItem(SESSION_KEY)
  if (cached) return JSON.parse(cached)

  try {
    const res: AxiosResponse<LocationResponse> = await axios.get(
      'https://ipinfo.io/json'
    )
    const { ip, region } = res.data
    const trimmedResponse = { ip, region }
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(trimmedResponse))
    return trimmedResponse
  } catch (e) {
    browserLogger.error('Failed to get location from ipinfo.io', {
      error: e,
    })
    return null
  }
}

// add a testing possibility to get state from url param in dev and staging environment.
const getMockLocation = (): LocationData | null => {
  const allowedMockLocation = isStaging || isDevelopment

  if (typeof window === 'undefined' || !allowedMockLocation) {
    return null
  }
  const params = new URLSearchParams(window.location.search)
  const region = params.get('mockRegion')
  if (region) {
    console.info('[Mock] Returning mocked location:', region)
    return { ip: '127.0.0.1', region }
  }
  return null
}
